import {AbstractControl, ValidationErrors, ValidatorFn, Validators} from "@angular/forms";
import {erTomEllerNil} from "felles-ng2/støttefunksjoner/strenger";
import {erTomHtmlTekst} from "felles-ng2/støttefunksjoner/htmlTekst";
import {erIkkeTomListe, erListe} from "felles-ng2/støttefunksjoner/lister";

export const litenStrengMaksLengde = 255;

/** Maks 255 tegn lang.
 * Se no.systemfabrikken.lederplan.infrastruktur.datatyper.Strenger.LitenStreng
 * @deprecated bruk FeltValidatorer isteden*/
export const litenStreng: ValidatorFn[] = [Validators.maxLength(litenStrengMaksLengde)];

/** Ikke tom, Maks 255 tegn lang. Validators.pattern(/\S+/) skal sjekke at det ikke kun er blnake tegn i teksten
 * Se no.systemfabrikken.lederplan.infrastruktur.datatyper.Strenger.LitenIkkeTomStreng
 * @deprecated bruk FeltValidatorer isteden*/
export const litenIkkeTomStreng: ValidatorFn[] = [Validators.required, Validators.pattern(/\S+/), ...litenStreng];

/** @deprecated bruk FeltValidatorer isteden*/
export function litenEllerLitenIkkeTomStreng(ikkeTom: boolean): ValidatorFn[] {
    return ikkeTom ? litenIkkeTomStreng : litenStreng;
}

export const storStrengMaksLengde = 65000;

/** Maks 65000 tegn lang.
 * Se no.systemfabrikken.lederplan.infrastruktur.datatyper.Strenger.StorStreng
 * @deprecated bruk FeltValidatorer isteden */
export const storStreng: ValidatorFn[] = [Validators.maxLength(storStrengMaksLengde)];

/** En html-formatert tekst som kan være hur lang som helst.
 * MERK at denne per nå returnerer en tom validator-liste.
 * Se no.systemfabrikken.lederplan.infrastruktur.datatyper.Strenger.HtmlTekst
 * @deprecated bruk FeltValidatorer isteden */
export const htmlTekst: ValidatorFn[] = [];

/** Epost, {@link Validators#email} og maks 255 tegn lang.
 * Se no.systemfabrikken.lederplan.domene.bruker.Epost
 * @deprecated bruk FeltValidatorer isteden */
export const epost: ValidatorFn[] = [Validators.email, Validators.maxLength(litenStrengMaksLengde)];

/** Mobilnummer, mellom 5 og 30 tegn.
 * Se no.systemfabrikken.lederplan.infrastruktur.datatyper.Mobilnummer
 * @deprecated bruk FeltValidatorer isteden */
export const mobilnummer: ValidatorFn[] = [Validators.minLength(5), Validators.maxLength(30)];

/** legger validatorene i en klasse, så import blir mer unike.**/
export class FeltValidatorer {
    /** Maks 255 tegn lang.
     * Se no.systemfabrikken.lederplan.infrastruktur.datatyper.Strenger.LitenStreng */
    static litenStreng: ValidatorFn[] = [Validators.maxLength(litenStrengMaksLengde)];

    /** Ikke tom, Maks 255 tegn lang. Validators.pattern(/\S+/) skal sjekke at det ikke kun er blanke tegn i teksten
     * Se no.systemfabrikken.lederplan.infrastruktur.datatyper.Strenger.LitenIkkeTomStreng */
    static litenIkkeTomStreng: ValidatorFn[] = [Validators.required, Validators.pattern(/\S+/), ...FeltValidatorer.litenStreng];

    static litenEllerLitenIkkeTomStreng(ikkeTom: boolean): ValidatorFn[] {
        return ikkeTom ? FeltValidatorer.litenIkkeTomStreng : FeltValidatorer.litenStreng;
    }

    /** Maks 65000 tegn lang.
     * Se no.systemfabrikken.lederplan.infrastruktur.datatyper.Strenger.StorStreng */
    static storStreng: ValidatorFn[] = [Validators.maxLength(storStrengMaksLengde)];

    /** Ikke tom, Maks 65000 tegn lang.
     * Se no.systemfabrikken.lederplan.infrastruktur.datatyper.Strenger.StorIkkeTomStreng*/
    static storIkkeTomStreng: ValidatorFn[] = [Validators.required, ...FeltValidatorer.storStreng];

    /** En html-formatert tekst som kan være hur lang som helst.
     * MERK at denne per nå returnerer en tom validator-liste.
     * Se no.systemfabrikken.lederplan.infrastruktur.datatyper.Strenger.HtmlTekst */
    static htmlTekst: ValidatorFn[] = [];

    /** Regel som angir at htmlTekst må være ikke tom (dvs må inneholde tekst).
     * Se {@link erTomHtmlTekst} */
    static htmlTekstPåkrevet: ValidatorFn[] = [(kontroll: AbstractControl): ValidationErrors | null => {
        return erTomHtmlTekst(kontroll.value) ? {'required': true} : null;
    }];

    /** Regexp for validering av epost.
     *  Modifikasjon av EMAIL_REGEXP i https://github.com/angular/angular/blob/main/packages/forms/src/validators.ts
     *  der siste * er erstattet med krav til toppnivådomenet må bestående av minst to bokstaver (og ikke tall/'-')
     *  Se no.systemfabrikken.lederplan.domene.bruker.jodd.mail.RFC2822AddressParserMedLangeTLDer for tilsvarende validering på server-siden.
     *  Merk at RFC2822AddressParserMedLangeTLDer benytter en svært komplisert regexp som er noe strengere enn denne.*/
    public static readonly gyldigEpost = /^(?=.{1,254}$)(?=.{1,64}@)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*\.[a-zA-Z]{2,24}$/;

    /** Epost, {@link Validators#email} og maks 255 tegn lang.
     * Se no.systemfabrikken.lederplan.domene.bruker.Epost
     * I motsetning til {@link Validators#email} krever vi at domene-delen inneholder minst to ledd,
     * altså forbys 'navn@noe' mens 'navn@noe.no' tillates */
    static epost: ValidatorFn[] = [
        (kontroll: AbstractControl): ValidationErrors | null => {
            if (erTomEllerNil(kontroll.value)) return null;
            return FeltValidatorer.gyldigEpost.test(kontroll.value) ? null : {'email': true};
        },
        Validators.maxLength(litenStrengMaksLengde)
    ];

    /** Mobilnummer, mellom 5 og 30 tegn.
     * Se no.systemfabrikken.lederplan.infrastruktur.datatyper.Mobilnummer */
    static mobilnummer: ValidatorFn[] = [Validators.minLength(5), Validators.maxLength(30)];


    /** Validerer at organisasjonsnummeret er gyldig for Norge. Tillater blanke tegn mellom tallene, null/'' anses som gyldig. */
    static norskOrganisasjonsnummer: ValidatorFn[] = [(kontroll: AbstractControl): ValidationErrors | null => {
        if (erTomEllerNil(kontroll.value)) return null;
        return FeltValidatorer.erNorskOrganisasjonsnummerGyldig(kontroll.value) ? null : {'norskOrganisasjonsnummer': true};
    }]

    /** Validerer at liste er ikke-tom */
    static ikkeTomListe: ValidatorFn[] = [(kontroll: AbstractControl): ValidationErrors | null => erIkkeTomListe(kontroll.value) ? null : {'ikkeTomListe': true}]

    /** Validerer at listen inneholder minst N elementer */
    static listeMedMinimumslengde(minimumslengde: number): ValidatorFn[] {
        return [kontroll => {
            const faktiskLengde = erListe(kontroll.value) ? kontroll.value.length : 0;
            console.log('## kontroll', kontroll, kontroll.value, faktiskLengde, minimumslengde);
            return faktiskLengde >= minimumslengde ? null : {'listeMedMinimumslengde': {faktisk: faktiskLengde, forventet: minimumslengde}};
        }];
    }

    /** Validerer at liste har angitt lengde */
    static listeMedLengde(forventetLengde: number): ValidatorFn[] {
        return [kontroll => {
            const faktiskLengde = erListe(kontroll.value) ? kontroll.value.length : 0;
            return faktiskLengde == forventetLengde ? null : {'listeMedLengde': {faktisk: faktiskLengde, forventet: forventetLengde}};
        }];
    }

    //private hjelpemetoder

    private static erNorskOrganisasjonsnummerGyldig = (organisasjonsnummer: any): boolean => {
        // fjern alle blanke tegn
        const organisasjonsnummerString = organisasjonsnummer.toString().replace(/\s/g, "");
        if (erTomEllerNil(organisasjonsnummerString)) return false;
        if (organisasjonsnummerString.length !== 9) return false;
        // kun siffer og og nøyaktig 9
        if(! /^\d+$/.test(organisasjonsnummerString)) return false;
        // kopiert fra https://github.com/storbukas/norsk-validator
        return parseInt(organisasjonsnummerString.charAt(organisasjonsnummerString.length - 1), 10) === FeltValidatorer.kontrollsiffferMod11(organisasjonsnummerString);
    }

    private static kontrollsiffferMod11 = (tall: any) => {
        const MOD11 = 11;
        let kontrollsiffer = 2;
        let sum = 0;

        for (let i = tall.length - 2; i >= 0; --i) {
            sum += tall.charAt(i) * kontrollsiffer;

            kontrollsiffer += 1;

            if (kontrollsiffer > 7) {
                kontrollsiffer = 2;
            }
        }

        const result = MOD11 - (sum % MOD11);

        return result === MOD11 ? 0 : result;
    };

}
